import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 40px);
  transform: translateX(-20px);
`

export const Image = styled.div`
  > span {
    display: block;
    height: 200px;
    background: no-repeat 50% 50% / contain;
  }
`

export const WishlistItem = styled.div`
  position: relative;
  width: calc(100% / 3 - 40px);
  margin: 20px;
  box-sizing: border-box;
  text-align: center;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);

  @media (max-width: 1023px) {
    width: calc(100% / 2 - 40px);
  }

  ${bp('sm')`
    width: 100%;
  `}

  > a {
    display: block;
    text-decoration: none;
    padding: 15px;

    > .title {
      color: ${props => props.theme.palette.general.strong};
      margin: 10px 0 20px;
      line-height: 1.4;
    }

    > .price {
      color: ${props => props.theme.palette.primary.beta};

      > .oldPrice {
        color: ${props => props.theme.palette.general.grey};
        text-decoration: line-through;
        margin: 0 5px 0 0;
      }
    }
  }
`

export const AddToWishlistContainer = styled.div`
  position: absolute;
  z-index: 2;
  right: 0;
  top: 0;
  padding: 15px;
`
